(() => {
  if (window.vitalShopLoaded) return;
  window.vitalShopLoaded = true;

  const money = cents => new Intl.NumberFormat(document.body.dataset.locale || 'de-DE', {style:'currency', currency:document.body.dataset.currency || 'EUR'}).format((Number(cents) || 0) / 100);
  const root = () => (document.body.dataset.root || '/').replace(/\/?$/, '/');
  const escapeHtml = value => String(value == null ? '' : value).replace(/[&<>"']/g, character => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#039;'}[character]));


  let drawerCartBusy = false;
  let discountSelection = [];
  let discountStorageKey = '';
  const couponLabels = () => JSON.parse(document.querySelector('[data-discount-labels]')?.textContent || '{}');
  const codeKey = value => String(value || '').trim().toUpperCase();
  const uniqueCodes = codes => [...new Set(codes.map(codeKey).filter(Boolean))];
  function couponMessage(message, state = '') {
    const element = document.querySelector('[data-discount-status]');
    if (element) { element.textContent = message; element.dataset.state = state; }
  }
  function saveCouponSelection(codes) {
    discountSelection = uniqueCodes(codes);
    try { if (discountStorageKey) sessionStorage.setItem(discountStorageKey, JSON.stringify(discountSelection)); } catch {}
  }
  function cartCouponCodes(cart) {
    return Array.isArray(cart.discount_codes) ? cart.discount_codes : [];
  }
  function isCouponApplied(cart, code) {
    const normalized = codeKey(code);
    if (cartCouponCodes(cart).some(item => codeKey(item.code) === normalized && item.applicable === true)) return true;
    const applications = [...(cart.cart_level_discount_applications || []), ...(cart.items || []).flatMap(item => (item.line_level_discount_allocations || []).map(allocation => allocation.discount_application))];
    return applications.some(item => item?.type === 'discount_code' && codeKey(item.title) === normalized && Number(item.total_allocated_amount) > 0);
  }
  function renderCoupons(cart) {
    const drawer = document.querySelector('[data-cart-drawer]');
    const list = drawer?.querySelector('[data-discount-codes]');
    if (!list) return;
    const labels = couponLabels();
    const key = 'vital-coupons:' + String(cart.token || '').split('?')[0];
    if (discountStorageKey !== key) {
      discountStorageKey = key;
      try { const saved = JSON.parse(sessionStorage.getItem(key) || '[]'); discountSelection = Array.isArray(saved) ? saved.filter(code => typeof code === 'string') : []; } catch { discountSelection = []; }
    }
    saveCouponSelection([...discountSelection, ...cartCouponCodes(cart).map(item => item.code)]);
    list.replaceChildren();
    discountSelection.forEach(code => {
      const li = document.createElement('li');
      const text = document.createElement('span');
      const name = document.createElement('strong'); name.textContent = code;
      const state = document.createElement('small'); state.textContent = isCouponApplied(cart, code) ? labels.applied : labels.pending;
      text.append(name, state);
      const remove = document.createElement('button'); remove.type = 'button'; remove.textContent = labels.remove;
      remove.setAttribute('aria-label', labels.remove + ': ' + code);
      remove.addEventListener('click', () => updateCoupon(null, code));
      li.append(text, remove); list.appendChild(li);
    });
    const hidden = drawer.querySelector('[data-checkout-discount]');
    hidden.value = discountSelection.join(','); hidden.disabled = discountSelection.length === 0;
    const row = drawer.querySelector('[data-cart-discount-total]');
    const discountAmount = Math.max(0, Number(cart.total_discount) || 0);
    row.hidden = discountAmount === 0;
    row.querySelector('strong').textContent = discountAmount ? '−' + money(discountAmount) : '';
  }
  function setCouponBusy(busy) {
    drawerCartBusy = busy;
    const drawer = document.querySelector('[data-cart-drawer]');
    const labels = couponLabels();
    drawer?.querySelectorAll('[data-discount-form] button,[data-discount-input],[data-discount-codes] button,[data-cart-checkout] button,[data-cart-minus],[data-cart-plus],[data-cart-remove]').forEach(element => { element.disabled = busy; });
    const button = drawer?.querySelector('[data-discount-apply]');
    if (button) button.textContent = busy ? labels.applying : labels.apply;
    drawer?.querySelector('[data-discount-form]')?.setAttribute('aria-busy', String(busy));
  }
  async function updateCoupon(newCode, removeCode) {
    if (drawerCartBusy) return;
    const labels = couponLabels();
    const input = document.querySelector('[data-discount-input]');
    const code = codeKey(newCode);
    if (!removeCode && !code) { couponMessage(labels.empty, 'error'); input.focus(); return; }
    if (!removeCode && code.includes(',')) { couponMessage(labels.invalid, 'error'); input.focus(); return; }
    setCouponBusy(true);
    couponMessage('');
    try {
      const before = await getCart();
      renderCoupons(before);
      let codes = uniqueCodes(discountSelection);
      codes = removeCode ? codes.filter(value => value !== codeKey(removeCode)) : uniqueCodes([...codes, code]);
      const response = await fetch(root() + 'cart/update.js', {
        method: 'POST', credentials: 'same-origin',
        headers: {'Content-Type':'application/json', Accept:'application/json'},
        body: JSON.stringify({discount: codes.join(',')})
      });
      const cart = await response.json();
      if (!response.ok || !Array.isArray(cart.items)) throw new Error(labels.error);
      saveCouponSelection(codes);
      renderCart(cart);
      if (removeCode) couponMessage(labels.removed, 'success');
      else {
        const applied = isCouponApplied(cart, code);
        couponMessage(applied ? labels.success : labels.not_applied, applied ? 'success' : 'error');
        input.value = '';
      }
    } catch {
      couponMessage(labels.error, 'error');
    } finally {
      setCouponBusy(false);
    }
  }
  function initCoupons() {
    const form = document.querySelector('[data-discount-form]');
    if (!form || form.dataset.ready) return;
    form.dataset.ready = 'true';
    form.addEventListener('submit', event => {
      event.preventDefault();
      updateCoupon(form.querySelector('[data-discount-input]').value);
    });
    form.querySelector('[data-discount-input]').addEventListener('input', () => couponMessage(''));
    document.querySelector('[data-cart-checkout]')?.addEventListener('submit', event => {
      if (drawerCartBusy) { event.preventDefault(); couponMessage(couponLabels().progress); return; }
      const input = form.querySelector('[data-discount-input]');
      if (input.value.trim()) { event.preventDefault(); couponMessage(couponLabels().checkout_error, 'error'); input.focus(); }
    });
  }

  async function getCart() {
    const response = await fetch(root() + 'cart.js', {headers:{Accept:'application/json'}});
    if (!response.ok) throw new Error('Der Warenkorb konnte nicht geladen werden.');
    return response.json();
  }

  function lineReference(item) {
    const saved = Number(item.properties && item.properties._vs_compare_at);
    return Math.max(item.original_price || 0, saved || 0);
  }

  function renderCart(cart) {
    document.querySelectorAll('[data-cart-count]').forEach(element => element.textContent = cart.item_count);
    const drawer = document.querySelector('[data-cart-drawer]');
    if (!drawer) return;
    const lines = drawer.querySelector('[data-cart-lines]');
    const empty = drawer.querySelector('[data-cart-empty]');
    const footer = drawer.querySelector('[data-cart-footer]');
    lines.innerHTML = '';
    empty.hidden = cart.item_count > 0;
    footer.hidden = cart.item_count === 0;

    cart.items.forEach(item => {
      const applications = Number(item.properties && item.properties._vs_applications) || 0;
      const perUse = applications > 0 ? money(item.final_line_price / (applications * item.quantity)) + ' pro Anwendung' : '';
      const reference = lineReference(item);
      const saved = Math.max(0, reference * item.quantity - item.final_line_price);
      const image = item.featured_image && item.featured_image.url ? item.featured_image.url : item.image;
      const article = document.createElement('article');
      article.className = 'vs-drawer-line';
      article.innerHTML =
        '<a class="vs-drawer-thumb" href="' + escapeHtml(item.url) + '">' + (image ? '<img src="' + escapeHtml(image) + '&width=240" alt="' + escapeHtml(item.product_title) + '" width="120" height="120">' : '') + '</a>' +
        '<div class="vs-drawer-copy"><a href="' + escapeHtml(item.url) + '"><strong>' + escapeHtml(item.product_title) + '</strong></a>' +
        (item.variant_title && item.variant_title !== 'Default Title' ? '<small>' + escapeHtml(item.variant_title) + '</small>' : '') +
        (perUse ? '<small class="vs-line-usage">' + escapeHtml(perUse) + '</small>' : '') +
        '<div class="vs-drawer-qty"><button type="button" data-cart-minus aria-label="Menge verringern">−</button><span>' + item.quantity + '</span><button type="button" data-cart-plus aria-label="Menge erhöhen">+</button><button class="vs-line-remove" type="button" data-cart-remove>Entfernen</button></div></div>' +
        '<div class="vs-drawer-price">' + (saved > 0 ? '<s>' + money(reference * item.quantity) + '</s>' : '') + '<strong>' + money(item.final_line_price) + '</strong>' + (saved > 0 ? '<small>Du sparst ' + money(saved) + '</small>' : '') + '</div>';
      article.querySelectorAll('[data-cart-minus],[data-cart-plus],[data-cart-remove]').forEach(button => {
        button.addEventListener('click', async () => {
          if (drawerCartBusy) return;
          setCouponBusy(true);
          const quantity = button.hasAttribute('data-cart-remove') ? 0 : Math.max(0, item.quantity + (button.hasAttribute('data-cart-plus') ? 1 : -1));
          try {
            const response = await fetch(root() + 'cart/change.js', {method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({id:item.key, quantity:quantity})});
            const updated = await response.json();
            if (!response.ok) throw new Error(updated.description || 'Menge konnte nicht geändert werden.');
            renderCart(updated);
          } catch (error) {
            const toast = document.querySelector('.vs-toast');
            if (toast) { toast.textContent = error.message; toast.hidden = false; setTimeout(() => { toast.hidden = true; }, 3000); }
          } finally { setCouponBusy(false); }
        });
      });
      lines.appendChild(article);
    });

    const referenceTotal = cart.items.reduce((sum, item) => sum + lineReference(item) * item.quantity, 0);
    const saving = Math.max(0, referenceTotal - cart.total_price);
    drawer.querySelector('[data-cart-total]').textContent = money(cart.total_price);
    const savingRow = drawer.querySelector('[data-cart-saving]');
    savingRow.hidden = saving <= 0;
    savingRow.querySelector('strong').textContent = saving > 0 ? money(saving) : '';
    renderCoupons(cart);
  }

  async function openCart() {
    const drawer = document.querySelector('[data-cart-drawer]');
    if (!drawer) { location.href = root() + 'cart'; return; }
    try {
      renderCart(await getCart());
      if (!drawer.open) drawer.showModal();
      document.documentElement.classList.add('vs-drawer-open');
    } catch (error) {
      location.href = root() + 'cart';
    }
  }

  function init(scope = document) {
    initCoupons();
    scope.querySelectorAll('[data-vs-product]').forEach(section => {
      if (section.dataset.ready) return;
      section.dataset.ready = 'true';
      const form = section.querySelector('.vs-product-form');
      const variants = JSON.parse(section.querySelector('[data-variants]').textContent);
      const campaignEnded = section.dataset.campaignEnd && Date.now() / 1000 > Number(section.dataset.campaignEnd);
      if (campaignEnded) variants.forEach(variant => { variant.available = false; });
      const labels = JSON.parse(section.querySelector('[data-product-labels]').textContent);
      const price = section.querySelector('[data-current-price]');
      const compare = section.querySelector('[data-compare-price]');
      const stickyPrice = section.querySelector('[data-sticky-price]');
      const button = form.querySelector('[name="add"]');
      const status = form.querySelector('.vs-form-status');
      const quantity = form.querySelector('[name="quantity"]');
      const stock = form.querySelector('.vs-stock-link');
      const selectedInput = () => form.querySelector('[name="id"]:checked') || form.querySelector('[name="id"]');
      const selected = () => variants.find(variant => String(variant.id) === String(new FormData(form).get('id')));
      const update = () => {
        const variant = selected();
        const input = selectedInput();
        if (!variant || !input) return;
        if (input.dataset.campaignImage) {
          const image = section.querySelector('.vs-main-image');
          if (image) { image.removeAttribute('srcset'); image.src = input.dataset.campaignImage; image.alt = variant.title; }
          section.querySelectorAll('[data-gallery-src]').forEach(thumb => thumb.setAttribute('aria-pressed', String(thumb.dataset.gallerySrc === input.dataset.campaignImage)));
        }
        price.textContent = money(variant.price);
        stickyPrice.textContent = money(variant.price);
        compare.hidden = !(variant.compare_at_price > variant.price);
        compare.textContent = compare.hidden ? '' : money(variant.compare_at_price);
        button.disabled = !variant.available;
        button.querySelector('[data-add-label]').textContent = variant.available ? labels.add : labels.soldOut;
        stock.hidden = variant.available;
        const applications = form.querySelector('[data-vs-applications]');
        const reference = form.querySelector('[data-vs-reference]');
        if (applications) applications.value = input.dataset.applications || 0;
        if (reference) reference.value = input.dataset.reference || variant.compare_at_price || variant.price;
        const rule = variant.quantity_rule || {};
        quantity.min = rule.min || 1;
        quantity.step = rule.increment || 1;
        if (rule.max) quantity.max = rule.max; else quantity.removeAttribute('max');
        if (Number(quantity.value) < Number(quantity.min)) quantity.value = quantity.min;
        status.replaceChildren();
        const url = new URL(location.href); url.searchParams.set('variant', variant.id); history.replaceState({}, '', url);
      };
      form.addEventListener('change', event => { if (event.target.name === 'id') update(); });
      section.querySelectorAll('[data-gallery-src]').forEach(thumb => thumb.addEventListener('click', () => {
        const image = section.querySelector('.vs-main-image');
        if (!image) return;
        image.removeAttribute('srcset'); image.src = thumb.dataset.gallerySrc; image.alt = thumb.dataset.galleryAlt;
        section.querySelectorAll('[data-gallery-src]').forEach(other => other.setAttribute('aria-pressed', String(other === thumb)));
      }));
      form.addEventListener('submit', async event => {
        if (!window.fetch || !window.FormData) return;
        event.preventDefault();
        if (form.dataset.submitting === 'true' || !selected()?.available) return;
        form.dataset.submitting = 'true'; button.disabled = true; button.setAttribute('aria-busy','true'); status.replaceChildren();
        try {
          const response = await fetch(root() + 'cart/add.js', {method:'POST', headers:{Accept:'application/json'}, body:new FormData(form)});
          const data = await response.json();
          if (!response.ok) throw new Error(data.description || data.message || labels.error);
          button.querySelector('[data-add-label]').textContent = labels.added;
          await openCart();
        } catch (error) {
          status.textContent = error.message || labels.error;
        } finally {
          form.dataset.submitting = 'false'; button.removeAttribute('aria-busy'); button.disabled = !selected()?.available;
        }
      });
      const sticky = section.querySelector('.vs-sticky-buy');
      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(entries => { sticky.classList.toggle('is-visible', !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0); }, {threshold:0});
        observer.observe(form);
        section._vitalObserver = observer;
      }
      update();
    });

    const header = document.querySelector('.vs-header');
    if (header) header.closest('.shopify-section')?.classList.add('vs-header-section');
    document.querySelectorAll('.vs-mobile-menu').forEach(menu => {
      if (menu.dataset.ready) return;
      menu.dataset.ready = 'true';
      menu.addEventListener('click', event => { if (event.target.closest('a')) menu.open = false; });
      menu.addEventListener('keydown', event => { if (event.key === 'Escape') { menu.open = false; menu.querySelector('summary').focus(); } });
    });
  }

  document.addEventListener('click', event => {
    if (event.target.closest('[data-cart-open]')) { event.preventDefault(); openCart(); }
    if (event.target.closest('[data-cart-close]')) {
      const drawer = document.querySelector('[data-cart-drawer]');
      drawer?.close(); document.documentElement.classList.remove('vs-drawer-open');
    }
  });
  document.addEventListener('click', event => {
    const drawer = event.target.closest('[data-cart-drawer]');
    if (drawer && event.target === drawer) { drawer.close(); document.documentElement.classList.remove('vs-drawer-open'); }
  });
  document.addEventListener('keydown', event => { if (event.key === 'Escape') document.documentElement.classList.remove('vs-drawer-open'); });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-vs-product]').forEach(section => section._vitalObserver?.disconnect()));
})();
